// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .top-logo {
    margin-bottom: 67px;
  }

  .error-icon {
    margin-bottom: 38px;
  }

  .button {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
`;

export const Message = styled.div`
  margin-bottom: 77px;
  text-align: center;
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: 1.5;
`;
